import { Box, Grid } from '@mui/material';
import { Button, Typography } from '@uhc-tempo/components';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormContext } from '../../context/Form.context';

const FallbackPage = () => {
    const history = useHistory();
    const { integrationType } = useContext(FormContext);
    return (
        <Box
            sx={{
                zIndex: 999,
                position: 'fixed',
                left: 0,
                top: 0,
                backgroundColor: '#fff',
                width: '100vw',
            }}
        >
            <Grid
                align="center"
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh' }}
            >
                <div aria-live="polite">
                    <Typography.H1>Sorry it's not you. It's Us.</Typography.H1>
                    <Typography.Paragraph>
                        We're experiencing an internal server problem. Try refreshing the page or
                        checking back soon.
                    </Typography.Paragraph>
                    {integrationType === 'member' && (
                        <div>
                            <Typography.Paragraph>
                                If you keep seeing this message, you can find health care by calling
                                the phone number listed on your ID card.
                            </Typography.Paragraph>
                        </div>
                    )}
                    {integrationType === 'advocate' && (
                        <div>
                            <Typography.Paragraph>
                                If you keep seeing this message, please follow your department
                                system outage guidelines.
                            </Typography.Paragraph>
                        </div>
                    )}
                </div>
                <Button
                    onClick={() => {
                        /*
                         * if we get an error from loggerProvider that is caught outside the routing layer
                         * we route the user back to the login page via a reload
                         */
                        if (history) {
                            history.goBack();
                        } else {
                            window.location.reload();
                        }
                    }}
                >
                    Try Again
                </Button>
            </Grid>
        </Box>
    );
};

export default FallbackPage;
